import React, { useContext, useRef, useState } from "react";
import Input from "../../../elements/Input";
import Button from "../../../elements/Button";
import { request } from "../../../utils/HttpRequest";
import { API_LINKS } from "../../../constant/Links";
import { LoginContext } from "../../../context/Login/LoginContext";
import { ROUTES } from "../../../constant/Routes";
import { useNavigate } from "react-router-dom";
import { LoadingContext } from "../../../context/Loading/LoadingContext";
import { AiOutlineLogin } from "react-icons/ai";

const fetchLogin = (
  mobileRef,
  pass,
  setMobileVal,
  loginContext,
  navigate,
  loadingContext
) => {
  const mobile = mobileRef.value;
  if (
    isNaN(parseInt(mobile)) ||
    mobile.length !== 11 ||
    mobile[0] + mobile[1] !== "09"
  ) {
    setMobileVal(false);
    mobileRef.focus();
    return;
  } else {
    setMobileVal(true);
  }
  loadingContext.startLoading();
  const obj = {
    mobile: mobile,
    password: pass,
  };
  request(
    API_LINKS.BASE + API_LINKS.LABORATORY.LOGIN,
    obj,
    (res) => {
      loginSuccess(res, loginContext, navigate, loadingContext);
    },
    (error) => {
      loginFailed(loadingContext);
    }
  );
};

const loginSuccess = (respons, loginContext, navigate, loadingContext) => {
  loadingContext.endLoading();
  if (respons.status) {
    loginContext.login(respons.info);
    navigate(ROUTES.ADDPAKAT);
  } else {
    alert(respons.msg);
  }
};

const loginFailed = (loadingContext) => {
  loadingContext.endLoading();
  alert("اشکال در برقراری ارتباط با سرور");
};

const Login = (props) => {
  const userNameRef = useRef(null);
  const passwordRef = useRef(null);
  const [mobileVal, setMobileVal] = useState(true);
  const loginContext = useContext(LoginContext);
  const loadingContext = useContext(LoadingContext);
  const navigate = useNavigate();

  const loginHandle = () => {
    fetchLogin(
      userNameRef.current,
      passwordRef.current.value,
      setMobileVal,
      loginContext,
      navigate,
      loadingContext
    );
  };

  return (
    <section className="bg-lightPrimary dark:bg-darkPrimary ">
      <div className="grid min-h-[calc(100vh-128px)] max-h-[calc(100vh-128px)] overflow-auto place-items-center">
        <div className="bg-lightSecondary dark:bg-darkSecondary rounded-2xl  shadow-2xl p-4 m-5 w-11/12 sm:w-1/4">
          <h1 className="text-center text-2xl mb-4 dark:text-darkTextPrimary text-lightTextPrimary">
            ورود
          </h1>
          <Input
            refrence={userNameRef}
            extraClass="rounded-2xl"
            type="text"
            inputMode="numeric"
            placeHolder="موبایل"
            maxLength="11"
            padding="p-3"
            mode={mobileVal ? "normal" : "error"}
            message={mobileVal ? "" : "موبایل را به درستی وارد کنید"}
          />
          <Input
            refrence={passwordRef}
            extraClass="rounded-2xl"
            type="password"
            placeHolder="رمز عبور"
            padding="p-3"
          />
          <div className="text-center ">
            <Button
              extraClass="my-4 text-darkTextPrimary"
              padding="py-3 px-10"
              icon={<AiOutlineLogin className="text-xl" />}
              type="submit"
              variant="success"
              content="ورود"
              rounded="rounded-2xl"
              onClick={() => {
                loginHandle();
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
